(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zeno-page-109409075294"] && !Shopify.designMode) return;
  try {
    (function(){
const root=document.getElementById('sessile-about-page');if(!root||root.dataset.ready==='true')return;root.dataset.ready='true';
const products={
hybrid:{title:'Adaptive Cooling Luxury Hybrid Mattress',cta:'Explore the Adaptive Hybrid',url:'/products/sessile-luxury-hybrid-mattress-independent-pocket-spring-memory-foam',layers:[['ADAPTIVE fabric','Moisture management','ADAPTIVE fabric helps move moisture away as you warm up.'],['Latex','Responsive cushioning','Latex cushions your body and springs back as you move.'],['Gel memory foam','Contouring comfort','Gel memory foam contours to your body beneath the fabric.'],['PureComfort foam','Additional cushioning','PureComfort foam adds cushioning above the springs.'],['Independent pocket springs','Underlying support','Individual pocket springs support your body beneath the comfort layers.']]},
topper:{title:'Blue Cooling Foldable Mattress Topper',cta:'Explore the Cooling Topper',url:'/products/sessile-blue-cooling-spine-back-care-medium-firm-foldable-mattress-topper',layers:[['Cool-touch cover','Cool at first contact','The smooth cover feels cool when you first lie down.'],['1.5 cm bamboo-charcoal foam','The upper comfort layer','1.5 cm of bamboo-charcoal memory foam cushions you beneath the cover.'],['3.5 cm support memory foam','Support beneath the surface','3.5 cm of support memory foam forms the topper’s base.']]},
pillow:{title:'Cooling Memory Foam Pillow',cta:'Explore the Cooling Pillow',url:'/products/refreshing-memory-foam-pillow',layers:[['Cool-touch outer cover','Cool at first contact','The washable cover feels cool against your head and neck.'],['Perforated memory foam','Paths for air to move','Honeycomb perforations give air paths through the foam.'],['3D mesh backing','A breathable backing','Open mesh lets air pass through the pillow’s backing.']]}}
const stack=root.querySelector('#ss-stack');let current='hybrid',selected=0;
function render(){const p=products[current];root.querySelector('#ss-product-title').textContent=p.title;const link=root.querySelector('#ss-product-link');link.href=p.url;link.textContent=p.cta+' ↗';root.querySelectorAll('[data-product]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.product===current)));stack.replaceChildren();p.layers.forEach((l,i)=>{const b=document.createElement('button');b.type='button';b.className='slab';b.setAttribute('aria-pressed',String(i===selected));b.setAttribute('aria-label','Explore '+l[0]);const s=document.createElement('span');s.textContent=l[0];const n=document.createElement('b');n.textContent=String(i+1);b.append(s,n);b.onclick=()=>{selected=i;render();save();};stack.append(b);});const l=p.layers[selected];root.querySelector('#ss-layer-kicker').textContent=l[1];root.querySelector('#ss-layer-title').textContent=l[0];root.querySelector('#ss-layer-copy').textContent=l[2];}
function restore(s){if(s&&products[s.product]){current=s.product;selected=Math.max(0,Math.min(Number(s.layer)||0,products[current].layers.length-1));}render();}
function save(){}
root.querySelectorAll('[data-product]').forEach(b=>b.onclick=()=>{current=b.dataset.product;selected=0;render();save();});restore(null);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zeno-product-7632852942942"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sessile-adaptive-detail')) {
    customElements.define('sessile-adaptive-detail', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const layerCopy = {
          1: ['Adaptive® Fabric', 'The sleep surface uses Adaptive® fabric to move moisture away and support a cooler, drier feel.'],
          2: ['Thai Latex', 'A responsive latex layer adds buoyant comfort and a gently lifted feel.'],
          3: ['Gel Memory Foam', 'Contouring gel memory foam cushions pressure points and conforms to your body.'],
          4: ['Pure Comfort Foam', 'A soft transition layer adds cushioning between the upper comfort materials and the support core.'],
          5: ['Individually Wrapped Pocket Springs', 'Individually wrapped springs respond separately to support the body and help limit motion transfer.']
        };
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.dataset.layerSelect) {
            const layer = button.dataset.layerSelect;
            if (!layerCopy[layer]) return;
            this.querySelectorAll('[data-layer-select]').forEach(item => {
              const active = item.dataset.layerSelect === layer;
              item.setAttribute('aria-pressed',String(active));
              item.classList.toggle('is-active',active);
            });
            this.querySelectorAll('[data-lift-layer]').forEach(piece => piece.classList.toggle('is-selected',piece.dataset.liftLayer===layer));
            const positions={1:11,2:21,3:32,4:43,5:61};
            this.querySelector('[data-lift-number]').textContent=String(layer).padStart(2,'0');
            this.querySelector('[data-lift-number]').style.top=positions[layer]+'%';
            this.querySelector('[data-lift-connector]').style.top=positions[layer]+'%';
            this.querySelector('.adaptive-lift-stage').setAttribute('aria-label','Exploded mattress illustration. '+layerCopy[layer][0]+' is lifted out and highlighted.');
            this.querySelector('[data-layer-title]').textContent=layerCopy[layer][0];
            this.querySelector('[data-layer-description]').textContent=layerCopy[layer][1];
          }
          for (const type of ['video','science']) {
            const previous=button.hasAttribute('data-'+type+'-prev');
            if (!previous && !button.hasAttribute('data-'+type+'-next')) continue;
            const track=this.querySelector('[data-'+type+'-track]');
            const first=track?.firstElementChild;
            if (!first) return;
            track.scrollBy({left:(previous?-1:1)*(first.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).gap)||0)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
          }
        },{signal});
        this.addEventListener('play',event=>{
          this.querySelectorAll('video').forEach(video=>{if(video!==event.target)video.pause();});
        },{capture:true,signal});
      }
      disconnectedCallback(){ this.controller?.abort();this.querySelectorAll('video').forEach(video=>video.pause()); }
    });
  }


if (!customElements.get('sessile-mattress-motion')) {
  customElements.define('sessile-mattress-motion', class extends HTMLElement {
    connectedCallback() {
      this.motionAbort?.abort();
      this.motionObserver?.disconnect();
      this.motionAbort = new AbortController();
      const start = card => {
        card.classList.remove('sd-playing');
        void card.offsetWidth;
        card.classList.add('sd-playing');
      };
      this.addEventListener('click', event => {
        const replay = event.target.closest('[data-replay]');
        if (replay && this.contains(replay)) start(replay.closest('[data-scene]'));
      }, {signal:this.motionAbort.signal});
      this.motionObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          start(entry.target.closest('[data-scene]'));
          this.motionObserver.unobserve(entry.target);
        });
      }, {threshold:.45});
      this.querySelectorAll('.sd-visual').forEach(visual => this.motionObserver.observe(visual));
    }
    disconnectedCallback() {
      this.motionAbort?.abort();
      this.motionObserver?.disconnect();
    }
  });
}


if(!customElements.get('sessile-core-motion')){
customElements.define('sessile-core-motion',class extends HTMLElement{
connectedCallback(){
this.coreAbort?.abort();this.coreObserver?.disconnect();this.coreAbort=new AbortController();
const play=()=>{this.classList.remove('sp-playing');void this.offsetWidth;this.classList.add('sp-playing');};
this.addEventListener('click',event=>{if(event.target.closest('.sp-replay'))play();},{signal:this.coreAbort.signal});
this.coreObserver=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){play();this.coreObserver.disconnect();}},{threshold:.45});
const photo=this.querySelector('.sp-original');
const observe=()=>this.coreObserver.observe(this);
if(photo.complete&&photo.naturalWidth)observe();else photo.addEventListener('load',observe,{once:true,signal:this.coreAbort.signal});
}
disconnectedCallback(){this.coreAbort?.abort();this.coreObserver?.disconnect();}
});
}
  } catch(e) { console.error(e); }
})();

})();
